export default "__VITE_ASSET__113831ac__"